import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Title = styled.h2`
    font-weight: 700;
    font-size: 30px;
    line-height: 120%;
    letter-spacing: -0.02em;
    color: #ffffff;
    margin: 0 0 20px 0;
    padding: 0;
`;

export const ColumnWrapper = styled.div`
    width: 100%;
    display: flex;
    margin-bottom: 120px;
    flex-direction: column;
`;

export const RulesGrid = styled.div`
    width: 100%;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    display: flex;
    flex-direction: column;
`;

export const RulesDisplay = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const TermsGrid = styled.div`
    padding-top: 40px;
    padding-bottom: 40px;

    display: flex;
    align-items: center;
    gap: 20px;
    flex-direction: column;

    a {
        font-size: 16px;
        line-height: 120%;
        font-weight: 500;
        opacity: 0.5;
        color: #ffffff;
        text-decoration: none;

        transition: all 0.2s ease-in-out;

        &:hover {
            text-decoration: underline;
            opacity: 1;
        }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        flex-direction: row;
        gap: 30px;
    }
`;
